import type { FeatureGateDecision, FeatureGateSeverity } from '@/hub-shared/gates/featureGateDecisions';

type FeatureGateNoticeProps = {
  decision: FeatureGateDecision;
  className?: string;
};

const severityForDecision = (decision: FeatureGateDecision): FeatureGateSeverity => {
  if (decision.severity) {
    return decision.severity;
  }
  return decision.reason === 'email_unverified' ? 'error' : 'warning';
};

const FeatureGateNotice = ({ decision, className }: FeatureGateNoticeProps) => {
  if (decision.allowed || !decision.message) {
    return null;
  }

  if (decision.reason === 'subscription_required') {
    const noticeClass = [
      'accounting-hub-notice',
      'accounting-hub-notice--subscription',
      className ?? '',
    ].filter(Boolean).join(' ');

    return (
      <div className={noticeClass} role="status" aria-live="polite">
        <p>{decision.message}</p>
        {decision.ctaHref && decision.ctaLabel ? (
          <a href={decision.ctaHref} className="btn-white" rel="noopener noreferrer">
            {decision.ctaLabel}
          </a>
        ) : null}
      </div>
    );
  }

  const severity = severityForDecision(decision);
  const noticeClass = [
    'accounting-hub-notice',
    `accounting-hub-notice-${severity}`,
    className ?? '',
  ].filter(Boolean).join(' ');

  return (
    <div
      className={noticeClass}
      role={severity === 'error' ? 'alert' : 'status'}
      aria-live={severity === 'error' ? 'assertive' : 'polite'}
    >
      <p>{decision.message}</p>
      {decision.ctaHref && decision.ctaLabel ? (
        <p className="accounting-hub-notice__cta">
          <a href={decision.ctaHref} rel="noopener noreferrer">
            {decision.ctaLabel}
          </a>
        </p>
      ) : null}
    </div>
  );
};

export default FeatureGateNotice;
